import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import Grid from '@mui/material/Grid';

const PageTitle = ({ title, subtitle, className, ...attrs }) => {
  const classes = classNames(
    className,
    "text-center",
    "text-md-left",
    "mb-sm-0"
  );

  return (
    // <Col xs="12" sm="4" className={classes} { ...attrs }>
    //  {/*  <span className="text-uppercase page-subtitle">{subtitle}</span> */}
    //   <h5 className="page-title py-3">{title}</h5>
    // </Col>
     <Grid item xs={12} sm={4} className={classes} {...attrs}>
     {/* Uncomment the following line if you want to include the subtitle */}
     {/* <span className="text-uppercase page-subtitle">{subtitle}</span> */}
     <h5 className="page-title py-3">{title}</h5>
   </Grid>
  )
};

PageTitle.propTypes = {
  /**
   * The page title.
   */
  title: PropTypes.string,
  /**
   * The page subtitle.
   */
  subtitle: PropTypes.string
};

export default PageTitle;
